<div class="page-container">
  <app-custom-back-button *ngIf="tabIndexToReturn" [customUrl]="customUrl"></app-custom-back-button>
  <div class="top-toolbar u-margin-bottom-50">
    <div class="sub-title">SETTINGS</div>
    <div class="o-flex o-flex--align-items-center">
      <div class="title u-margin-right-10">Metric Settings</div>
    </div>
  </div>
  <div class="u-margin-top-20">
    <div>
      <app-maximum-aerobic-panel
        [heading]="'Maximum Aerobic Speed/Power'"
        [featureEnabled]="metricEnabled('max_aerobic')"
        [featureId]="getIdForFeature('max_aerobic')"
      ></app-maximum-aerobic-panel>
      <app-maximum-aerobic-panel
        [heading]="'Maximum Speed/Power'"
        [featureEnabled]="metricEnabled('max_power')"
        [featureId]="getIdForFeature('max_power')"
      ></app-maximum-aerobic-panel>
    </div>
  </div>
</div>
